import SEO from "@/components/SEO";
import Hero from "@/components/home/Hero";
import CapabilityStrip from "@/components/home/CapabilityStrip";
import IntroStatement from "@/components/home/IntroStatement";
import ServicesEditorial from "@/components/home/ServicesEditorial";
import BusinessStatement from "@/components/home/BusinessStatement";
import DataJourney from "@/components/home/DataJourney";
import IndustriesFeature from "@/components/home/IndustriesFeature";
import CaseStudyFeature from "@/components/home/CaseStudyFeature";
import OutcomesSection from "@/components/home/OutcomesSection";
import WhySection from "@/components/home/WhySection";
import InsightsFeatured from "@/components/home/InsightsFeatured";
import FinalCTA from "@/components/home/FinalCTA";

export default function Home() {
  return (
    <>
      <SEO
        title="All Data Tech | AI, Data Engineering & Analytics Solutions"
        description="All Data Tech builds AI, data engineering, analytics, business intelligence and cloud solutions that help businesses turn data into better decisions and measurable outcomes."
        path="/"
      />
      <Hero />
      <CapabilityStrip />
      <IntroStatement />
      <ServicesEditorial />
      <BusinessStatement />
      <DataJourney />
      <IndustriesFeature />
      <CaseStudyFeature />
      <OutcomesSection />
      <WhySection />
      <InsightsFeatured />
      <FinalCTA />
    </>
  );
}
